import { render, staticRenderFns } from "./SettingButtons.vue?vue&type=template&id=460278ea&"
import script from "./SettingButtons.vue?vue&type=script&lang=js&"
export * from "./SettingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports